import { render, staticRenderFns } from "./CafeTable.vue?vue&type=template&id=f0550788&"
import script from "./CafeTable.vue?vue&type=script&lang=js&"
export * from "./CafeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports